import { ExternalLink, BookOpen } from "lucide-react";
import { Link } from "react-router-dom";
import blogBg from "@/assets/blog-bg.webp";
import ScrollReveal from "./ScrollReveal";

const BlogSection = () => {
  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background image with gradient overlay */}
      <div className="absolute inset-0">
        <img
          src={blogBg}
          alt="Ambiente acolhedor"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-primary/80 via-primary/60 to-accent/50" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <ScrollReveal className="max-w-3xl mx-auto text-center" blur={16}>
          <p className="text-primary/70 font-semibold uppercase tracking-[0.2em] text-sm mb-3">
            Blog
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary-foreground mb-4">
            Artigos Equilybra Company
          </h2>
          <div className="w-16 h-1 mx-auto mb-6 rounded-full bg-gradient-to-r from-primary to-accent opacity-70" />
          <p className="text-primary-foreground/80 leading-relaxed mb-10 text-base md:text-lg">
            Descubra um mundo de conhecimento e bem-estar em nosso blog! Visite a seção de artigos da Equilybra Company e encontre conteúdos ricos sobre saúde mental, dicas práticas para o dia a dia, estratégias de autocuidado, e muito mais. Nossos especialistas compartilham informações valiosas para ajudar você a viver uma vida mais equilibrada e saudável.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/blog"
              className="inline-flex items-center gap-2.5 px-8 py-4 rounded-2xl bg-primary/90 backdrop-blur-sm text-primary-foreground font-semibold hover:bg-primary transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 text-base border border-primary-foreground/10"
            >
              <BookOpen className="w-5 h-5" />
              Ler artigos aqui
            </Link>
            <a
              href="https://equilybrapsicologia.blogspot.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2.5 px-8 py-4 rounded-2xl bg-primary-foreground/10 backdrop-blur-sm text-primary-foreground font-semibold hover:bg-primary-foreground/20 transition-all duration-300 text-base border border-primary-foreground/20"
            >
              <ExternalLink className="w-5 h-5" />
              Blog Equilybra Company
            </a>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default BlogSection;
